import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const quizRunsApi = createApi({
  reducerPath: 'quizRunsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getLatestQuizRun: builder.query({
      query: (params) => ({
        url: urls.quizRuns,
        params,
      }),
    }),
    saveQuizRun: builder.mutation({
      query: (body) => ({
        url: urls.quizRuns,
        method: 'POST',
        data: body,
      }),
    }),
    updateQuizRun: builder.mutation({
      query: ({ id, body }) => ({
        url: urls.quizRunDetail(id),
        method: 'PUT',
        data: body,
      }),
    }),
  }),
});

export const {
  useGetLatestQuizRunQuery,
  useSaveQuizRunMutation,
  useUpdateQuizRunMutation,
} = quizRunsApi;
